export default __webpack_public_path__ + "static/logo-dxbot-portal-3b1a0c714e57f5e75b59d22ea986dd55.png";